// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ltm-root section {
    margin-bottom: 32px;
}

.ltm-section-heading {
    align-items: baseline;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
}

.ltm-root .ltm-section-heading h2 {
    margin-bottom: 0;
}

.ltm-table {
    width: 100%;
}

.ltm-row-actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    align-items: center;
}

.ltm-add-row {
    align-items: center;
    border-top: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
}
[data-theme="dark"] .ltm-add-row { border-top-color: #2c3a33; }

.ltm-form-modal .modal__content {
    overflow-y: auto;
}

.ltm-form-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 16px;
}

.ltm-icon-preview {
    align-items: center;
    display: flex;
    gap: 8px;
    margin: 8px 0 0;
}

.ltm-icon-preview i {
    font-size: 1.5em;
}

@media (max-width: 640px) {
    .ltm-root section {
        margin-bottom: 24px;
    }

    .ltm-section-heading {
        align-items: flex-start;
        flex-direction: column;
        gap: 4px;
        margin-bottom: 18px;
    }

    .ltm-root .ltm-section-heading h2 {
        margin-bottom: 0;
        width: 100%;
    }

    .ltm-root .ltm-section-heading .subtitle {
        display: inline-flex;
        font-size: 0.95rem;
        margin: 0;
    }

    .ltm-root .tablewrapper {
        overflow: visible;
    }

    .ltm-table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .ltm-table thead {
        display: none;
    }

    .ltm-table tr {
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        display: block;
        margin-bottom: 14px;
        border: 1px solid #ddd;
        border-radius: 6px;
        padding: 10px 12px;
    }

    .ltm-table td {
        align-items: start;
        border-bottom: 1px solid #eee;
        display: grid;
        gap: 10px;
        grid-template-columns: 86px minmax(0, 1fr);
        min-width: 0;
        text-align: left;
        padding: 9px 0;
        word-break: break-word;
    }

    .ltm-table td:first-child {
        padding-top: 0;
    }

    .ltm-table td:last-child {
        border-bottom: 0;
        padding-bottom: 0;
    }

    .ltm-table td::before {
        color: #333;
        content: attr(data-label);
        font-size: 0.82rem;
        font-weight: 600;
        line-height: 1.4;
    }
    [data-theme="dark"] .ltm-table tr { background: #1c2620; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4); border-color: #3a463e; }
    [data-theme="dark"] .ltm-table td { border-bottom-color: #2c3a33; }
    [data-theme="dark"] .ltm-table td::before { color: #9fb0a6; }

    .ltm-table td a {
        overflow-wrap: anywhere;
    }

    .ltm-table td[data-label="Move"],
    .ltm-table td[data-label="Actions"] {
        align-items: center;
    }

    .ltm-row-actions {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
    }

    .ltm-row-actions .button.small {
        align-items: center;
        display: flex;
        justify-content: center;
        min-height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        width: 100%;
    }

    .ltm-add-row {
        margin-top: 18px;
        padding-top: 18px;
    }

    .ltm-add-row .lti-root {
        width: 100%;
    }

    .ltm-add-row .button {
        display: flex;
        justify-content: center;
        min-height: 44px;
        width: 100%;
    }

    .ltm-form-actions {
        align-items: stretch;
        flex-direction: column;
    }

    .ltm-form-actions .button {
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Links/LinkTreeManager.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;AACA,mCAAmC,yBAAyB,EAAE;;AAE9D;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,yCAAyC;QACzC,cAAc;QACd,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,aAAa;QACb,SAAS;QACT,0CAA0C;QAC1C,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;IACA,oCAAoC,mBAAmB,EAAE,wCAAwC,EAAE,qBAAqB,EAAE;IAC1H,oCAAoC,4BAA4B,EAAE;IAClE,4CAA4C,cAAc,EAAE;;IAE5D;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,gDAAgD;QAChD,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,WAAW;IACf;AACJ","sourcesContent":[".ltm-root section {\n    margin-bottom: 32px;\n}\n\n.ltm-section-heading {\n    align-items: baseline;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 12px;\n}\n\n.ltm-root .ltm-section-heading h2 {\n    margin-bottom: 0;\n}\n\n.ltm-table {\n    width: 100%;\n}\n\n.ltm-row-actions {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.ltm-add-row {\n    align-items: center;\n    border-top: 1px solid #ddd;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 20px;\n    padding-top: 20px;\n}\n[data-theme=\"dark\"] .ltm-add-row { border-top-color: #2c3a33; }\n\n.ltm-form-modal .modal__content {\n    overflow-y: auto;\n}\n\n.ltm-form-actions {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    margin-top: 16px;\n}\n\n.ltm-icon-preview {\n    align-items: center;\n    display: flex;\n    gap: 8px;\n    margin: 8px 0 0;\n}\n\n.ltm-icon-preview i {\n    font-size: 1.5em;\n}\n\n@media (max-width: 640px) {\n    .ltm-root section {\n        margin-bottom: 24px;\n    }\n\n    .ltm-section-heading {\n        align-items: flex-start;\n        flex-direction: column;\n        gap: 4px;\n        margin-bottom: 18px;\n    }\n\n    .ltm-root .ltm-section-heading h2 {\n        margin-bottom: 0;\n        width: 100%;\n    }\n\n    .ltm-root .ltm-section-heading .subtitle {\n        display: inline-flex;\n        font-size: 0.95rem;\n        margin: 0;\n    }\n\n    .ltm-root .tablewrapper {\n        overflow: visible;\n    }\n\n    .ltm-table {\n        border-collapse: separate;\n        border-spacing: 0;\n    }\n\n    .ltm-table thead {\n        display: none;\n    }\n\n    .ltm-table tr {\n        background: #fff;\n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n        display: block;\n        margin-bottom: 14px;\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        padding: 10px 12px;\n    }\n\n    .ltm-table td {\n        align-items: start;\n        border-bottom: 1px solid #eee;\n        display: grid;\n        gap: 10px;\n        grid-template-columns: 86px minmax(0, 1fr);\n        min-width: 0;\n        text-align: left;\n        padding: 9px 0;\n        word-break: break-word;\n    }\n\n    .ltm-table td:first-child {\n        padding-top: 0;\n    }\n\n    .ltm-table td:last-child {\n        border-bottom: 0;\n        padding-bottom: 0;\n    }\n\n    .ltm-table td::before {\n        color: #333;\n        content: attr(data-label);\n        font-size: 0.82rem;\n        font-weight: 600;\n        line-height: 1.4;\n    }\n    [data-theme=\"dark\"] .ltm-table tr { background: #1c2620; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4); border-color: #3a463e; }\n    [data-theme=\"dark\"] .ltm-table td { border-bottom-color: #2c3a33; }\n    [data-theme=\"dark\"] .ltm-table td::before { color: #9fb0a6; }\n\n    .ltm-table td a {\n        overflow-wrap: anywhere;\n    }\n\n    .ltm-table td[data-label=\"Move\"],\n    .ltm-table td[data-label=\"Actions\"] {\n        align-items: center;\n    }\n\n    .ltm-row-actions {\n        display: grid;\n        gap: 8px;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        width: 100%;\n    }\n\n    .ltm-row-actions .button.small {\n        align-items: center;\n        display: flex;\n        justify-content: center;\n        min-height: 40px;\n        padding-left: 10px;\n        padding-right: 10px;\n        width: 100%;\n    }\n\n    .ltm-add-row {\n        margin-top: 18px;\n        padding-top: 18px;\n    }\n\n    .ltm-add-row .lti-root {\n        width: 100%;\n    }\n\n    .ltm-add-row .button {\n        display: flex;\n        justify-content: center;\n        min-height: 44px;\n        width: 100%;\n    }\n\n    .ltm-form-actions {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .ltm-form-actions .button {\n        align-items: center;\n        display: flex;\n        justify-content: center;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
